import { useState } from "react";
import AbstractController from "../../../../vendors/services/abstractController";
import EventoService from "../../../services/evento.service";
import PortalFilter from "../filters/PortalFilter";
import ToastService from "../../../../vendors/services/toastService";
import { Mensagem } from "../../../shared/mensagem/Mensagem";
import EventoModel from "../../../shared/model/evento.model";

export default class PortalController extends AbstractController {
  private service: EventoService;
  public filter: PortalFilter;

  public lista: any;
  public setLista: any;
  public anoList: any;
  public setAnoList: any;
  public tipoEventoList: any;
  public setTipoEventoList: any;
  public situacaoList: any;
  public setSituacaoList: any;
  public total: any;
  public setTotal: any;
  public evento: EventoModel;
  public setEvento: any;

  public lazyParams: any;
  public setLazyParams: any;
  public visibleLogin: any;
  public setVisibleLogin: any;

  constructor() {
    super();
    [this.lista, this.setLista] = useState([]);
    [this.total, this.setTotal] = useState(0);
    [this.lazyParams, this.setLazyParams] = useState({
      first: 0,
      rows: 10,
      page: 1,
    });
    [this.anoList, this.setAnoList] = useState([]);
    [this.tipoEventoList, this.setTipoEventoList] = useState([]);
    [this.situacaoList, this.setSituacaoList] = useState([]);
    [this.visibleLogin, this.setVisibleLogin] = useState(false);
    [this.evento, this.setEvento] = useState(Object);

    this.service = new EventoService();
    this.filter = new PortalFilter();
  }

  init() {
    super.init();
    this.filter.setCodigoSituacao(2);
    this.consultarPadrao();
    this.getAnoList();
  }

  getAnoList() {
    this.service.getAno().then((res: any) => {
      this.setAnoList(res.result);
    });
  }

  getSituacaoList() {
    this.service.getSituacao().then((res: any) => {
      this.setSituacaoList(res.result);
    });
  }

  getTipoEventoList() {
    this.service.getTipoEvento().then((res: any) => {
      this.setTipoEventoList(res.result);
    });
  }

  onPage(e: any) {
    if (this.temFiltroUsuario()) {
      this.consultarFiltro(e.page, e.rows, e);
    } else {
      this.consultarPadrao(e.page, e.rows, e);
    }
  }

  temFiltroUsuario() {
    return !!(
      this.filter.busca ||
      this.filter.numeroAudiencia ||
      this.filter.codigoAno
    );
  }

  consultarPadrao(
    page: number = 0,
    pageSize: number = 10,
    e?: any,
    ordering: any = null
  ) {
    const obj: any = {
      codigoSituacao: 2,
      ordering: ordering != null ? ordering : this.filter.ordering || "ano",
      page,
      pageSize,
    };
    this.executarConsulta(obj, e);
  }

  consultarFiltro(
    page: number = 0,
    pageSize: number = 10,
    e?: any,
    ordering: any = null
  ) {
    const obj: any = {
      busca: this.filter.busca,
      numeroAudiencia: this.filter.numeroAudiencia,
      codigoAno: this.filter.codigoAno,
      codigoSituacao: this.filter.codigoSituacao || 2,
      ordering: ordering != null ? ordering : this.filter.ordering || "ano",
      page,
      pageSize,
    };
    if (!obj.busca && !obj.numeroAudiencia && !obj.codigoAno) {
      ToastService.showWarn(Mensagem.MSG_E055);
      return;
    }
    this.executarConsulta(obj, e);
  }

  consultar(
    page: number = 0,
    pageSize: number = 10,
    isClean = false,
    e?: any,
    ordering: any = null,
    isInit = false
  ) {
    if (isInit || isClean) {
      this.consultarPadrao(page, pageSize, e, ordering);
      return;
    }
    this.consultarFiltro(page, pageSize, e, ordering);
  }

  private executarConsulta(obj: any, e?: any) {
    const params: any = { ...obj };
    this.start();
    this.service
      .findAll(params)
      .then((res) => {
        this.stop();
        if (e) {
          this.setLazyParams(e);
        }
        if (res.result && res.result.items) {
          this.setLista(res.result.items);
          this.setTotal(res.result.totalItems);
        } else {
          this.setLista([]);
          this.setTotal(0);
        }
      })
      .catch(() => this.stop());
  }

  async shareEvent(params: {
    dsLink: string;
    dsEmail: string;
    dsNota: string;
  }): Promise<any> {
    try {
      this.start();
      await this.service.compartilharEvento(params);
      this.stop();
      ToastService.showSuccess("Compartilhamento realizado com sucesso!");
    } catch (err) {
      this.stop();
      ToastService.showError("Erro ao compartilhar evento!");
    }
  }

  async getEvento(id: number) {
    try {
      const res: any = await this.service.getEvento(id, this.getCodContribuinte() + 0);
      return res.result.dsLinkDivulgacaoEvento;
    } catch (error) {
      console.error('Erro ao buscar evento:', error);
      throw error;
    }
  }

  public limpar() {
    this.setLazyParams({ first: 0, rows: 10, page: 1 });
    this.filter.limpar();
    this.filter.setCodigoSituacao(2);
    this.consultarPadrao();
  }
}
